<template>
  <div v-if="product.powerReviewsID">
    <div :id="`pr-reviewsnippet-${product.powerReviewsID}`" class="pr-reviewsnippet" />
  </div>
</template>
<script>
export default {
  name: 'PdpReviewsSummary',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
